import { render, staticRenderFns } from "./DashboardIslandOrders.vue?vue&type=template&id=77344ef4&"
import script from "./DashboardIslandOrders.vue?vue&type=script&lang=js&"
export * from "./DashboardIslandOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports